
import { List } from 'immutable';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { mkChartOfAccount } from 'data/chartOfAccounts/types';
import { getCoaString, isIncomeCat } from 'data/categories/retrievers';
import { mkBudgetItem } from 'data/budgetItems/budgetItemsTypes';

export const createNewBudgetItems = (budget, groupId, dateRange, itemInfo) => {

  let itemsToAdd = new List();
  let startingDate = moment(moment(dateRange.startDate).format('YYYY-MM-01'));
  const isIncome = itemInfo.coa && isIncomeCat(itemInfo.coa.id);

  do {
    const newBudgetItem = mkBudgetItem({
      clientId: uuidv4().toUpperCase(),
      budgetId: budget.id,
      startDate: moment(startingDate).format('YYYY-MM-DD'),
      amount: (isIncome ? itemInfo.amount : -itemInfo.amount),
      coa: itemInfo.coa && mkChartOfAccount(itemInfo.coa),
      groupId,
      name: itemInfo.name || getCoaString(itemInfo.coa),
      type: itemInfo.budgetItemType || 'COA',
    });
    itemsToAdd = itemsToAdd.push(newBudgetItem);
    startingDate = startingDate.add(1, 'month');
  } while (startingDate.month() !== 0);

  return itemsToAdd;
};
export const setAmountSign = (amt, coa) => {

  // for the budget item, we flip the sign for expense cats when this amount was provided
  // from the category review card
  if (coa) {
    return isIncomeCat(coa.id) ? amt : -amt;
  }
  return amt;
};
